module.exports = __webpack_public_path__ + "static/zopim-b986e60e9db3d9c9ce85f15ccf8668bf.svg";